module.exports = __webpack_public_path__ + "bff12d0f9246348cf0b51c6aab37dcae.svg";